import * as yup from 'yup'

export const suspendVendorSchema = yup.object({
  duration: yup
    .string()
    .required('Suspension duration is required')
    .oneOf(
      ['7', '30', '60', '90', '180', '365', 'permanent'],
      'Please select a valid duration',
    ),
  reason: yup
    .string()
    .required('Reason for suspension is required')
    .min(10, 'Reason must be at least 10 characters long')
    .max(500, 'Reason must not exceed 500 characters')
    .trim(),
})

export type SuspendVendorFormData = yup.InferType<typeof suspendVendorSchema>

export const formatDurationForAPI = (duration: string): string => {
  if (duration === 'permanent') return 'permanent'
  return `${duration}_days`
}
